// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c24615a4","195":"a92a227b","257":"4b8d7e91","267":"5ee4edd5","302":"7146f5a5","386":"b3a24bd2","488":"58a358a2","498":"818125b4","534":"1f5a8b12","617":"5b3654b6","648":"767538ac","696":"4160075f","854":"ebaff889","924":"0c94a562","973":"3d4d5605"}[chunkId] + ".chunk.js";
};